<img src="{{ data.url }}">
<div class="lightbox-date" *ngIf="data.createdAt">
  <mat-icon fontSet="fal" fontIcon="fa-clock" class="fa-fw"></mat-icon>
  {{ data.createdAt | dateTimeFormat }}
</div>
<button mat-fab color="primary" class="close-button" (click)="onClose()">
  <mat-icon fontSet="fal" fontIcon="fa-times"></mat-icon>
</button>